export default __webpack_public_path__ + "static/P_SearchThumb_IN-8403WQHD-7c3ed2100a890b25d39c216296091bd2.webp";